const getMessageOnly = baseId => ({
  id: 'message',
  name: 'Message Only Campaign',
  description: 'Message',
  version: 1,
  rootNodeId: `${baseId}message`,
  comment: 'template',
  nodes: [
    {
      type: 'IVR_NODE_MESSAGE',
      ivrNode: {
        id: `${baseId}message`,
        name: 'Message',
        description: 'Message',
        nextId: '',
        message: {
          message:
            'Thanks for contacting us. We are currently not taking any phone calls. Please email or text us instead. ',
          type: 'TEXT',
          language: 'en-US',
          voice: '',
        },
      },
    },
  ],
});

export default getMessageOnly;
